var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',[_c('UpperHeader')],1),_c('MainMenu'),_c('main',[_c('router-view')],1),_c('footer',[_c('KlantLogos')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }